/* tslint:disable */
import {
  FundsAccount,
  Sector
} from '../index';

declare var Object: any;
export interface VoteHeadsInterface {
  "name": string;
  "description"?: string;
  "id"?: number;
  "funds_account_id"?: number;
  "sector_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  fundsAccount?: FundsAccount;
  sector?: Sector;
}

export class VoteHeads implements VoteHeadsInterface {
  "name": string;
  "description": string;
  "id": number;
  "funds_account_id": number;
  "sector_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  fundsAccount: FundsAccount;
  sector: Sector;
  constructor(data?: VoteHeadsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `VoteHeads`.
   */
  public static getModelName() {
    return "VoteHeads";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of VoteHeads for dynamic purposes.
  **/
  public static factory(data: VoteHeadsInterface): VoteHeads{
    return new VoteHeads(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'VoteHeads',
      plural: 'VoteHeads',
      path: 'VoteHeads',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "funds_account_id": {
          name: 'funds_account_id',
          type: 'number'
        },
        "sector_id": {
          name: 'sector_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        fundsAccount: {
          name: 'fundsAccount',
          type: 'FundsAccount',
          model: 'FundsAccount'
        },
        sector: {
          name: 'sector',
          type: 'Sector',
          model: 'Sector'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/VoteHeads.ts